import IntroductionSection from "./IntroductionSection.js";
import EmotionalAwarenessExplainedSection from "./EmotionalAwarenessExplainedSection.js";
import RecognizingEmotionalPatternsSection from "./RecognizingEmotionalPatternsSection.js";
import NamingEmotionsSection from "./NamingEmotionsSection.js";
import EmotionalTriggersSection from "./EmotionalTriggersSection.js";
import EmotionalRegulationSection from "./EmotionalRegulationSection.js";
import UnderstandingShameSection from "./UnderstandingShameSection.js";
import UnderstandingAngerSection from "./UnderstandingAngerSection.js";
import BuildingEmotionalResilienceSection from "./BuildingEmotionalResilienceSection.js";
import BringingItTogetherSection from "./BringingItTogetherSection.js";

const SECTION_COMPONENTS = {
  introduction: IntroductionSection,
  "emotional-awareness-explained": EmotionalAwarenessExplainedSection,
  "recognizing-emotional-patterns": RecognizingEmotionalPatternsSection,
  "naming-emotions": NamingEmotionsSection,
  "emotional-triggers": EmotionalTriggersSection,
  "emotional-regulation": EmotionalRegulationSection,
  "understanding-shame": UnderstandingShameSection,
  "understanding-anger": UnderstandingAngerSection,
  "building-emotional-resilience": BuildingEmotionalResilienceSection,
  "bringing-it-together": BringingItTogetherSection,
};

export default SECTION_COMPONENTS;
